import styled from 'styled-components';

export const ResearchProjectStyle = styled.div`
  position: relative;
  display: flex;
  min-height: calc(100vh - 100px);

  .heading {
    display: block;
    font-size: 20px;
    line-height: 24px;
    font-weight: 700;
    margin: 0 0 15px;
  }
  .title {
    display: block;
    font-size: 18px;
    line-height: 22px;
    font-weight: 700;
    margin: 0 0 15px;
  }

  .left-column {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-grow: 1;
    padding: 0 15px 0 0;

    .header {
      width: 100%;
      border-bottom: 1px solid #cdcdcd;
      padding-bottom: 15px;
      margin-bottom: 20px;
    }

    .content-area {
      flex-grow: 1;

      .head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin: 0 0 15px;
      }
    }
  }

  .scroll-area {
    width: 100%;
    padding-right: 5px;
    overflow-y: auto;
    /* height: calc(100vh - 405px); */
  }

  .no-threads {
    width: 100%;
    font-size: 18px;
    line-height: 24px;
    padding: 60px 20px;
    margin: 0 0 10px;
    text-align: center;
    color: var(--light-gray);
    border: 1px solid #cdcdcd;
    border-radius: 10px;
    background: var(--white);
  }

  .right-column {
    width: 100%;
    max-width: 450px;
    padding: 0 0 0 15px;
    border-left: 1px solid #cdcdcd;

    .text-holder {
      width: 100%;
      text-align: center;
      padding: 35px 60px;
      color: var(--light-gray);
      border-radius: 15px;
      border: 1px solid #cdcdcd;
      background: var(--white);

      .icon-box {
        font-size: 30px;
        line-height: 1;
        margin: 0 0 15px;
      }

      .title {
        color: var(--text-color);
        margin: 0 0 10px;
      }

      p {
        margin: 0 0 25px;
      }
    }
  }
`;
